import { render, staticRenderFns } from "./RegistrationCitizenshipFormDatePicker.vue?vue&type=template&id=979635a4&"
import script from "./RegistrationCitizenshipFormDatePicker.vue?vue&type=script&lang=ts&"
export * from "./RegistrationCitizenshipFormDatePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports